
                export const appVersionDetails =
                {
  "Major":2,
  "Minor":3,
  "Patch":11,
  "PreReleaseTag":"",
  "PreReleaseTagWithDash":"",
  "PreReleaseLabel":"",
  "PreReleaseNumber":"",
  "BuildMetaData":"",
  "BuildMetaDataPadded":"",
  "FullBuildMetaData":"Branch.master.Sha.0540ec9fe35c6efde5c8a2035f913bfb302209a4",
  "MajorMinorPatch":"2.3.11",
  "SemVer":"2.3.11",
  "LegacySemVer":"2.3.11",
  "LegacySemVerPadded":"2.3.11",
  "AssemblySemVer":"2.3.11.0",
  "AssemblySemFileVer":"2.3.11.0",
  "FullSemVer":"2.3.11",
  "InformationalVersion":"2.3.11+Branch.master.Sha.0540ec9fe35c6efde5c8a2035f913bfb302209a4",
  "BranchName":"master",
  "Sha":"0540ec9fe35c6efde5c8a2035f913bfb302209a4",
  "NuGetVersionV2":"2.3.11",
  "NuGetVersion":"2.3.11",
  "NuGetPreReleaseTagV2":"",
  "NuGetPreReleaseTag":"",
  "CommitsSinceVersionSource":0,
  "CommitsSinceVersionSourcePadded":"0000",
  "CommitDate":"2025-05-02"
}

                ;
            


// WEBPACK FOOTER //
// ./src/app/appVersionDetails.ts